import { BoxV2 as Box, ExpandableText, Flex, Grid } from 'portal-commons';
import React, { FC, MouseEvent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';

import { EventData } from '@/applications/MnoPortal/Events/types';
import { CroppableItem } from '@/components';
import { getEventTypeImage } from '@/constants';
import { convertTimeWithTimezone } from '@/utils/time';
import { humanizeAuthenticatedUser } from '@/utils/string';

interface Props {
  event: EventData;
  withoutUser?: boolean;
}

const EventsListingRow: FC<Props> = ({ event, withoutUser = false }) => {
  const createDate = convertTimeWithTimezone(event.createDate);
  const authenticatedUser = humanizeAuthenticatedUser(event.authenticatedUser);
  return (
    <TableRow data-testid="eventsListingRow">
      <TableCell
        style={{
          maxWidth: 150,
        }}
        align="left"
        data-testid="eventsListingRowEventType"
      >
        <Flex sx={{ alignItems: 'center' }}>
          <Box sx={{ mr: 's' }}>{getEventTypeImage(event.eventType)}</Box>
          <CroppableItem title={event.eventType} sx={{ fontWeight: 500 }}>
            {event.eventType || '--'}
          </CroppableItem>
        </Flex>
      </TableCell>
      <TableCell align="left" data-testid="eventsListingRowCategoryType">
        {event.categoryType}
      </TableCell>
      <TableCell align="left" data-testid="eventsListingRowCampaignUid">
        {event.campaignUid}
      </TableCell>
      <TableCell align="left" data-testid="eventsListingRowBrandUid">
        {event.brandUid}
      </TableCell>
      <TableCell
        style={{ maxWidth: 150 }}
        data-testid="eventsListingRowCreateDate"
      >
        <CroppableItem title={createDate}>{createDate}</CroppableItem>
      </TableCell>
      {!withoutUser && (
        <TableCell
          style={{ maxWidth: 120 }}
          data-testid="eventsListingRowAuthenticatedUser"
        >
          <CroppableItem title={authenticatedUser}>
            {authenticatedUser}
          </CroppableItem>
        </TableCell>
      )}
      <TableCell
        align="left"
        onClick={(e: MouseEvent<HTMLTableCellElement>) => e.stopPropagation()}
        data-testid="eventsListingRowDescription"
      >
        <Grid
          sx={{
            gridTemplateColumns: 'minmax(200px, 1fr)',
            width: '100%',
          }}
        >
          <ExpandableText text={event.description} maxWidth="100%" />
        </Grid>
      </TableCell>
    </TableRow>
  );
};

export default EventsListingRow;
